import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAdminProject,
  fetchAdminJobApplicationJobs,
  fetchAdminJobApplications,
  fetchProjectDetails,
  fetchProjectFreelancer,
  fetchProjectUploadeableDetails,
  inviteToProject,
  updateProjectStatus,
  uploadDocumentByAdmin,
} from "../actions/projectAction";

const initialState = {
  isLoading: false,
  isViewProjectDetails: false,
  isInvite: false,
  projectList: {},
  projectHeader: [
    "S.No.",
    "Title",
    "Subimitted By",
    "Status",
    "Subimitted On",
    "Action",
  ],
  projectData: {},
  deliveableList: [],
  jobApplications: [],
  selectedJobId: "",
  selectedJob: {},
  jobApplicationCounts: {},
  selectedJobTab: "all",
};

const projectSlice = createSlice({
  name: "admin-projects",
  initialState,
  reducers: {
    setIsViewProjectDetails: (state, action) => {
      state.isViewProjectDetails = action.payload;
    },
    setIsInvite: (state, action) => {
      state.isInvite = action.payload;
    },
  },
  extraReducers: (builder) => {

    // fetchAdminProject
    builder.addCase(fetchAdminProject.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminProject.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      const projects = data?.projects || [];
      const funding = projects.filter((item) => {
        const typeValue = String(
          item?.project_type ||
          item?.type ||
          item?.category ||
          item?.project_category ||
          "",
        ).toLowerCase();
        return typeValue.includes("funding");
      });
      const service = projects.filter((item) => {
        const typeValue = String(
          item?.project_type ||
          item?.type ||
          item?.category ||
          item?.project_category ||
          "",
        ).toLowerCase();
        return typeValue.includes("service");
      });
      state.projectList = {
        all: projects,
        funding,
        service,
        job_post: state.projectList?.job_post || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchAdminProject.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateProjectStatus
    builder.addCase(updateProjectStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateProjectStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateProjectStatus.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-project-details
    builder.addCase(fetchProjectDetails.pending, (state, action) => {

      state.isLoading = true;
    });
    builder.addCase(fetchProjectDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.projectData = data || {};
      state.isViewProjectDetails = true;
      state.isLoading = false;
    });
    builder.addCase(fetchProjectDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-project-freelancer
    builder.addCase(fetchProjectFreelancer.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectFreelancer.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.matchFreelancerList = data?.talents || []
      state.isLoading = false;
    });
    builder.addCase(fetchProjectFreelancer.rejected, (state, action) => {

      state.isLoading = false;
    });

    // updateProjectStatus
    builder.addCase(inviteToProject.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(inviteToProject.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(inviteToProject.rejected, (state, action) => {
      state.isLoading = false;
    });

    // uploadDocumentByAdmin
    builder.addCase(uploadDocumentByAdmin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(uploadDocumentByAdmin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(uploadDocumentByAdmin.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchProjectUploadeableDetails
    builder.addCase(fetchProjectUploadeableDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProjectUploadeableDetails.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.deliveableList = data?.deliverables || []
      state.isLoading = false;
    });
    builder.addCase(fetchProjectUploadeableDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchAdminJobApplicationJobs
    builder.addCase(fetchAdminJobApplicationJobs.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminJobApplicationJobs.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      const jobs =
        data?.jobs ||
        data?.job_posts ||
        data?.projects ||
        data ||
        [];
      state.projectList = {
        ...state.projectList,
        job_post: Array.isArray(jobs) ? jobs : [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchAdminJobApplicationJobs.rejected, (state) => {
      state.isLoading = false;
    });

    // fetchAdminJobApplications
    builder.addCase(fetchAdminJobApplications.pending, (state, action) => {
      state.isLoading = true;
      state.selectedJobId = String(action?.meta?.arg?.job_id || "");
    });
    builder.addCase(fetchAdminJobApplications.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.selectedJob = data?.selected_job || {};
      state.selectedJobId = String(
        data?.selected_job_id || action?.meta?.arg?.job_id || "",
      );
      state.jobApplicationCounts = data?.counts || {};
      state.selectedJobTab = data?.selected_tab || "all";
      state.jobApplications =
        data?.applications ||
        data?.job_applications ||
        data?.applicants ||
        data ||
        [];
      state.isLoading = false;
    });
    builder.addCase(fetchAdminJobApplications.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default projectSlice.reducer;
export const { setIsViewProjectDetails, setIsInvite } = projectSlice.actions;
